import { render, staticRenderFns } from "./asa.vue?vue&type=template&id=71269f78&scoped=true"
import script from "./asa.vue?vue&type=script&lang=js"
export * from "./asa.vue?vue&type=script&lang=js"
import style0 from "./asa.vue?vue&type=style&index=0&id=71269f78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71269f78",
  null
  
)

export default component.exports